/**
 * API pagination limits for grants module
 * @see docs/specifications/2026-01-30-recommendation-details-project-context.md
 */
export const API_PAGINATION_LIMITS = {
  /** Maximum calls to fetch for project context section */
  PROJECT_CALLS: 50,
  /** Maximum recommendations to fetch for related recommendations section */
  PROJECT_RECOMMENDATIONS: 20,
} as const;
